"use client"

import { Image, Col, Row, Select } from "antd"
import { toast } from "react-toastify"
import BookingProgresses from "./BookingProgresses"
import BookingTimmer from "./BookingTimer"
import Header from "@/components/common/Layout/Header"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import PageHeaderMobile from "@/components/common/PageHeaderMobile"
import { useParams, usePathname } from "next/navigation"
import { useTERouter } from "@/hooks/app/useTERouter"
import { useTranslation } from "react-i18next"
import VietnamIcon from "@/components/icons/VietnameIcon"
import Text from "@/components/common/Typography/Text"
import dayjs from "dayjs"
import { thunks } from "@/lib/redux/thunks"

const BookingLayoutHeader = () => {
  const step_booking = useAppSelector(state => state.booking.step_booking)
  const bookingTimerHidden = useAppSelector(state => state.booking.bookingTimerHidden)
  const dispatch = useAppDispatch()
  const isDesktop = useIsDesktop()
  const router = useTERouter()
  const params = useParams()
  const pathName = usePathname()
  const { t, i18n } = useTranslation()

  const isNotResultBooking = step_booking !== 'result' && (!params?.orderCode || pathName.includes('/booking/repayment'))
  const isPayment = pathName.includes('/booking/flight/checkout') || pathName.includes('/booking/repayment')
  const isHotelBooking = pathName.includes('/booking/hotel')

  const mobileTitle = isPayment
    ? t("common.payment")
    : isHotelBooking
      ? t("hotel.hotel_info_title")
      : isNotResultBooking
        ? t("booking.order_info")
        : t("booking.pass_info")

  return (
    <Header style={{ zIndex: 10 }} className={`layout-booking__header ${step_booking === 'result' ? ' layout-booking__header--result' : ''}`}>
      <Row className="layout-booking__header-content" align='middle'>
        <Col span={24}>
          {/* DESKTOP */}
          {isDesktop && (
            <Row align='middle' className="layout-booking__header--top">
              <Col onClick={() => router.push("/")}>
                <Row align='middle'>
                  <Image
                    preview={false}
                    height={'4rem'}
                    width={"15rem"}
                    alt="Travel easy logo on header"
                    src="/static/images/travel-easy-logo-v2-2x.jpg"
                    style={{ cursor: "pointer", lineHeight: '1' }}
                    styles={{
                      root: { lineHeight: '1' }
                    }}
                    onClick={() => router.push("/")}
                  />
                </Row>
              </Col>
              <Col flex={1} className="layout-booking__header-steps">
                <Row justify='center' align='middle'>
                  <Col flex={"1 1 84rem"}>
                    <BookingProgresses />
                  </Col>
                </Row>
              </Col>
            </Row>
          )}

          {/* MOBILE */}
          {!isDesktop && (
            <PageHeaderMobile
              style={{ zIndex: 10 }}
              title={mobileTitle}
                    rightContent={(
                      <Select
                        variant="borderless"
                        size="small"
                        value={i18n.language === "en" ? "en" : "vi"}
                        className="layout-booking__language-select"
                        getPopupContainer={() => document.body}
                        options={[
                          {
                            label: <Row wrap={false} align="middle"><VietnamIcon /><Text>VI | VND</Text></Row>,
                            value: "vi",
                          },
                          {
                            label: <Row wrap={false} align="middle"><img width={22} height={22} alt="american-flag-icon" src="/static/images/american-flag-icon.png" /><Text>EN | USD</Text></Row>,
                            value: "en",
                          },
                        ]}
                        onChange={async (language: "vi" | "en") => {
                          if (language === "en") {
                            try {
                              await dispatch(thunks.get_exchange_currency({})).unwrap()
                            } catch {
                              toast.error(t("common.exchange_currency_failed"))
                              return
                            }
                          }
                          dayjs.locale(language)
                          router.push(pathName
                            .replace("/vi/", `/${language}/`)
                            .replace("/en/", `/${language}/`)
                            .replace("/vi", `/${language}`)
                            .replace("/en", `/${language}`)
                          )
                          i18n.changeLanguage(language)
                        }}
                      />
                    )}
                    shownRight
              className="layout-booking__header--top-mobile--box"
              onLeftClick={() => {
                router.back()
              }}
            />
          )}

          {isNotResultBooking && !bookingTimerHidden && (<BookingTimmer />)}
        </Col>
      </Row>
    </Header>
  )
}

export default BookingLayoutHeader